import ManageAnamnese from '@/views/consultations/en-cours/histoire-de-la-maladie/manage-anamnese'

export default {
    name: 'histoire-de-la-maladie',
    components: {
        ManageAnamnese
    },
    props: {
        consultation: Object,
        section_name: String,
        evolution_id: Number,
        evolution_toggler: Number,
        current_consultation_evolution: Number
    },
    data() {
        return {
            anamnese_is_loading: true,
            is_empty: false,
            data_to_be_deleted: {},
            list_atcd_anamneses: [],
            group_id: 0
        }
    },

    watch: {
        evolution_toggler() {
            this.getHistoireAnamnese()
        }
    },

    computed: {
        histoire_anamnese() {
            return this.$store.getters["histoire_anamnese"];
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        evolution_id_initiale() {
            return this.$store.getters['evolution_id_initiale']
        }
    },

    mounted() {
        this.getHistoireAnamnese()
    },

    methods: {
        addAnamnese(group_id) {
            this.list_atcd_anamneses = []
            this.group_id = group_id
        },

        editAnamnese(group_id, anamneses) {
            this.group_id = group_id
            this.list_atcd_anamneses = anamneses
        },

        async getHistoireAnamnese() {
            this.anamnese_is_loading = true

            let filter_data = {
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id_initiale,
                data_type: 'histoire_de_la_maladie',
                est_en_cours: true
            }

            this.$store.dispatch('getConsultationAntecedent', filter_data).then(() => {
                if (this.histoire_anamnese.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }

                this.anamnese_is_loading = false
            })
        },

        removeGroupAnamnese(group) {
            this.data_to_be_deleted = {
                libelle: group.reference,
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                user_id: this.userCredentials.id,
                group_id: group.anamnese_group_id
            }
        }
    }
}


